import Appsignal from "@appsignal/javascript";
import { plugin as windowEventsPlugin } from "@appsignal/plugin-window-events";
import { plugin as pathPlugin } from "@appsignal/plugin-path-decorator";
import settings from "../settings";

const getInstance = () => {
  const instance = new Appsignal({
    key: settings.appsignal_key,
    revision: settings.heroku_slug_commit,
  });

  instance.use(windowEventsPlugin());
  instance.use(pathPlugin());

  return instance;
};

const appsignal = settings.appsignal_key ? getInstance() : null;

const logger = ((): {sendError(err: Error): void, sendMessage(message: string): void} => {
  if (appsignal) {
    // eslint-disable-next-line no-console
    console.log("Appsignal available");

    return {
      sendError: (err: Error | ErrorEvent) => {
        try {
          if ((err instanceof Error) || (err instanceof ErrorEvent)) {
            // @ts-ignore
            appsignal.sendError(err);
          } else {
            appsignal.sendError(new Error(JSON.stringify(err)));
          }
        } catch (error) {
          if (error instanceof Error) {
            console.error(error);
          }
        }
      },
      sendMessage: (message:string) => {
        try {
          throw new Error(message);
        } catch (error) {
          if (error instanceof Error) {
            appsignal.sendError(error);
          }
        }
      },
    };
  }
  return {
    sendError (err: Error) {
      console.error(err);
    },
    sendMessage (message: string) {
      // eslint-disable-next-line no-console
      console.log(message);
    },
  };
})();

export default logger;
